import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication/authentication.service';
import { LoggingService } from './logging/logging.service';
import { LazyLoadEvent } from '../models/DataTables/lazyLoadEvent';
import { CreateDynamicAsset, DynamicAsset, EditDynamicAsset } from '../models/inModels/DynamicAsset';

@Injectable()
export class AssetService {
  private route = '/api/assets';
  constructor(private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

    search(event: LazyLoadEvent): Promise<any> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/search`, JSON.stringify(event), { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }

    get(id: number): Promise<DynamicAsset> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response as DynamicAsset)
        .catch(error => this.logging.handleError(error));
    }

    create(user: CreateDynamicAsset): Promise<DynamicAsset> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/create`, JSON.stringify(user), { headers: this.auth.header })
        .toPromise()
        .then(response => response as DynamicAsset)
        .catch(error => this.logging.handleError(error));
    }
    
    delete(id: number): Promise<any> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }

    update(user: EditDynamicAsset): Promise<DynamicAsset> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/update`, JSON.stringify(user), { headers: this.auth.header })
        .toPromise()
        .then(response => response as DynamicAsset)
        .catch(error => this.logging.handleError(error));
      }
}



// WEBPACK FOOTER //
// ./src/app/services/asset.service.ts